/* LUNA PDP behaviour — D44/D46/D48-D71/D78.
   D78 (B14): options are generalised. Size matches Size/Sizing; Origin stays
   special (USA toggle); EVERY other option is an axis with its own picker row.
   Gallery filtering is per COLOUR axis: an image whose alt names a value of an
   axis shows only while that value is selected (longest-value match per axis, so
   "Black Hemp" never collides with "Black"); alts naming no colour value always
   show. D69: sampled photo grounds belong to card mode ONLY.
   D240 (Liv, 09-11) SPLITS THAT D69 RULE IN TWO. See the note on the sampler.
   D97 (Liv): no dead ATC — before a size is picked the button stays GOLD and
   says "Select a size"; clicking it scrolls to and pulses the size grid.
   D177 (Liv): partsOf tolerates a stray space between the M/W letter and its
   number. See the note on the function.
   D183 (Liv): the accordions are an exclusive set - opening one closes the rest.
   D185 (Liv): and the panel slides open rather than snapping.
   D205 (Liv): isDual, and what it fixed. See the note on the function.
   D373 (Liv, 09-16): size chips whose label is words rather than a number used
   to overflow their box and print across their neighbours. See szWideCss. */
(function(){
  if(window.__lunaPdp) return; window.__lunaPdp = true;
  var KEY = 'luna.size', GKEY = 'luna.gender';
  function lsGet(k){ try{ return localStorage.getItem(k); }catch(e){ return null; } }
  function lsSet(k, v){ try{ localStorage.setItem(k, v); }catch(e){} }
  function money(c){ return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : '$' + (c/100).toFixed(2); }
  function norm(s){ return String(s).toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function pretty(s){ return String(s).replace(/([a-z])([A-Z])/g, '$1 $2'); }

  /* D373 (Liv, 09-16) — LONG SIZE LABELS OVERFLOWED THEIR CHIPS AND OVERLAPPED.

     She sent the Merino and Fluffy YUBI tabi socks, where "Small (M4-6/W6-8)",
     "Medium (M6.5-8.5/W8.5-10.5)" and the rest printed straight across one
     another, unreadable. Same on Polar Feet socks, Tech Straps, the LUNAtic
     Bracelet and both gift cards: every product that types a size as WORDS.

     CAUSE, two rules in luna-pdp.css that are each correct alone:
       .luna-pdp__sizes  grid-template-columns: repeat(auto-fill, minmax(54px,1fr))
       .luna-pdp__sz b   white-space: nowrap
     The track floors at 54px and the label refuses to wrap, so anything longer
     than a sandal size runs out of its box and over the chip beside it. 54px is
     the D239 decision and nowrap is what keeps "10.5" on one line; they are only
     wrong TOGETHER, and only for a value that is not a number.

     SANDAL PDPs MUST NOT MOVE. D181 and D239 both tuned that grid and the D45
     mobile gate (19 dual chips legible at 375px) was verified against it, so the
     fix is a modifier class that is only ever added when a label needs it.

     THRESHOLD IS 5 CHARACTERS, chosen against the real data:
       sandal dual labels      "10.5", "11.5"        4   stays a grid
       non-dual sandal sizes   "M10.5"               5   stays a grid
       Brujita                 "W12"                 3   stays a grid
       LUNAtic Bracelet        "Medium"              6   goes wide
       gift cards              "$125.00"             7   goes wide
       tabi socks, straps      "Small (M4-6/W6-8)"  17   goes wide
     6 is the case worth catching: "Medium" in 14px mono is about 55px, already
     wider than the 54px track, and it would have overflowed silently.

     EVERY SELECTOR BELOW DOUBLES THE CLASS, AND THAT IS NOT DECORATION.
     The first cut wrote `.luna-pdp__sizes--wide{display:flex}`, which is one
     class, (0,1,0) — exactly the same weight as the `.luna-pdp__sizes` grid rule
     it has to beat. At equal specificity the LATER sheet wins, and luna-pdp.css
     is linked after this injected block, so the container stayed display:grid
     while the chip rules (two classes, so heavier) applied. The result was
     chips that wrapped their text but stayed 54px wide, which fixed the overlap
     and looked barely better. Verified in the browser, not assumed.
     `.luna-pdp__sizes.luna-pdp__sizes--wide` is (0,2,0) and wins regardless of
     source order. Do not simplify these selectors.
     Note also that luna-tokens.css cannot host these rules: it is wrapped in
     @layer luna-base, and a layered rule always loses to unlayered component CSS
     no matter how specific it is.

     THE RULES ARE INJECTED FROM HERE RATHER THAN LIVING IN luna-pdp.css, which
     is not where CSS belongs and is a deliberate trade. Nothing on the theme
     links a separate stylesheet, so shipping these three rules as a file meant
     re-sending luna-pdp.liquid (30KB) byte for byte on top of this file, which
     had to change anyway for the toggle. Two large re-sends of load-bearing
     files to place three rules is the worse risk. The chips are built by
     renderSizes() below, so a reader with no JS has no chips to style either:
     nothing degrades that was not already gone. */
  var szCssDone = false;
  function szWideCss(){
    if(szCssDone) return;
    szCssDone = true;
    if(document.getElementById('luna-sz-wide')) return;
    var s = document.createElement('style');
    s.id = 'luna-sz-wide';
    s.textContent =
      '.luna-pdp__sizes.luna-pdp__sizes--wide{display:flex;flex-wrap:wrap}' +
      '.luna-pdp__sizes.luna-pdp__sizes--wide .luna-pdp__sz{height:auto;min-height:38px;padding:9px 14px;flex:0 1 auto;max-width:100%}' +
      '.luna-pdp__sizes.luna-pdp__sizes--wide .luna-pdp__sz b{white-space:normal}';
    document.head.appendChild(s);
  }

  /* D177: sizes are typed "M4.5 W6.5" and split on the space into a men's part
     and a women's part. Four products typed one of theirs with a space after the
     letter - "M4.5 W 6.5" - which split into THREE parts, so parts[1] was the bare
     letter "W", bare() stripped it to nothing, and the women's chip rendered
     blank. The data has since been corrected, but the guard stays: it costs
     nothing and the typo can be retyped at any time. */
  function partsOf(v){ return String(v).trim().replace(/([MW]) +(?=[0-9.])/g, '$1').split(/ +/); }
  function bare(t){ var c = t.charAt(0); return (c === 'M' || c === 'W') ? t.slice(1) : t; }

  /* D205 (Liv, 09-10): "is this value LUNA's dual men/women size?"

     hasDual used to be `partsOf(v).length > 1` — any size value containing a
     space. That is true of a great many things that are not sandal sizes, and
     the fallout was visible on the storefront:

       merino YUBI tabi socks, sized  Small (M4-6/W6-8) ... XXL (M12+)
         -> Men's / Women's tabs appeared on a pair of SOCKS
         -> men's chips read  Small, edium, Large, XL, XXL
            because bare() strips a leading M or W, and "Medium" starts with M
         -> women's chips read  (M4-6/W6-8), (M6.5-8.5/W8.5-10.5), ...
            the parenthetical, with the size name thrown away

     Same for Correct Toes, tech straps and the lace replacement service, all of
     which put a bracketed LUNA range after a letter size.

     The test is now the exact shape LUNA uses: two parts, M<number> and
     W<number>, nothing else. partsOf still repairs the "W 11.5" stray space
     first, so Origen 2.0 and Origen Lite stay dual. Sandal-only sizes like
     "M10.5" are correctly NOT dual on their own; a product counts as dual if
     ANY of its values is, which is what makes those render on the men's tab
     and vanish from the women's.

     D373 NOTE: the same products that forced this function are the ones whose
     chips overflowed. Words where a sandal puts a number breaks the labels
     (fixed here) and then the layout (fixed in szWideCss). Expect a third.

     Written with parseFloat rather than a regex ON PURPOSE. The first cut used
     /^M[0-9]+(?:\.[0-9]+)?$/ and shipped through a GraphQL block string, which
     passes backslashes through untouched, so a doubled backslash survived into
     the asset and the pattern quietly matched a literal backslash instead of a
     decimal point. Every whole size still matched, so nothing looked wrong.
     There is no backslash here now, and no way for one to creep back in. */
  function numTail(t, letter){
    if(t.charAt(0) !== letter) return false;
    var rest = t.slice(1);
    return rest.length > 0 && String(parseFloat(rest)) === rest;
  }
  function isDual(v){
    var p = partsOf(v);
    return p.length === 2 && numTail(p[0], 'M') && numTail(p[1], 'W');
  }

  function init(root){
    if(root.__luna) return; root.__luna = true;
    var data;
    try{ data = JSON.parse(root.querySelector('[data-luna-pdp-data]').textContent); }catch(e){ return; }
    var opts = data.options || [], variants = data.variants || [];
    var sizeOpt = null, originOpt = null, axes = [];
    opts.forEach(function(o){
      if(/^siz(e|ing)$/i.test(o.name)) sizeOpt = o;
      else if(/^origin$/i.test(o.name)) originOpt = o;
      else if(!/^title$/i.test(o.name)) axes.push({ name: o.name, values: o.values, colourish: /colou?r/i.test(o.name) });
    });
    var hasDual = !!sizeOpt && sizeOpt.values.some(isDual);
    var mensMin = parseFloat(root.dataset.mensMin) || 0;
    var shipMin = parseInt(root.dataset.shipMin, 10) || 0;
    var st = { size: null, gender: (lsGet(GKEY) === 'w' && hasDual) ? 'w' : 'm' };
    axes.forEach(function(ax){ st[ax.name] = ax.values[0]; });
    if(originOpt) st[originOpt.name] = originOpt.values[0];

    var colourAxes = axes.filter(function(ax){ return ax.colourish; });
    colourAxes.forEach(function(ax){
      ax.norms = ax.values.map(function(v){ return { v: v, n: norm(v) }; })
        .filter(function(x){ return x.n; })
        .sort(function(a, b){ return b.n.length - a.n.length; });
    });

    function match(over){
      var want = {};
      opts.forEach(function(o){
        var v = (over && over[o.name] !== undefined) ? over[o.name] : (o === sizeOpt ? st.size : st[o.name]);
        want[o.name] = v;
      });
      return variants.filter(function(v){
        return opts.every(function(o,i){ var w = want[o.name]; return w == null || v.o[i] === w; });
      });
    }
    function availableFor(sizeVal, originVal){
      var over = {}; if(sizeOpt) over[sizeOpt.name] = sizeVal;
      if(originOpt && originVal != null) over[originOpt.name] = originVal;
      return match(over).some(function(v){ return v.a; });
    }
    function current(){ var m = match(); return m.length ? m[0] : null; }
    function otherOrigin(){
      if(!originOpt) return null;
      return originOpt.values.filter(function(v){ return v !== st[originOpt.name]; })[0] || null;
    }

    var els = {
      price: root.querySelector('[data-pdp-price]'),
      sizes: root.querySelector('[data-pdp-sizes]'),
      tabs: root.querySelector('[data-pdp-tabs]'),
      readout: root.querySelector('[data-pdp-readout]'),
      rescue: root.querySelector('[data-pdp-rescue]'),
      atc: root.querySelector('[data-pdp-atc]'),
      stock: root.querySelector('[data-pdp-stock]'),
      gal: root.querySelector('[data-pdp-gal]'),
      more: root.querySelector('[data-pdp-more]'),
      count: root.querySelector('[data-pdp-count]'),
      up: root.querySelector('[data-pdp-up]'),
      axes: root.querySelector('[data-pdp-axes]'),
      tfc: root.querySelector('[data-pdp-tfc]'),
      rebuy: root.querySelector('[data-pdp-rebuy]'),
      ship: root.querySelector('[data-pdp-ship]'),
      sizedir: root.querySelector('[data-pdp-sizedir]')
    };
    var shipFallback = els.ship ? els.ship.textContent : '';
    var shipQ = els.ship ? (els.ship.dataset.q || shipFallback) : '';
    var limit = parseInt(root.dataset.galLimit, 10) || 6;
    var expanded = false;

    var items = els.gal ? Array.prototype.slice.call(els.gal.querySelectorAll('.luna-pdp__gi')) : [];

    /* D241 (Liv, 09-11): this used to open with

           if(!img.naturalWidth) return null;

       as a cheap "has it decoded yet" test. That is a PROXY for the thing we
       actually care about, and it can be wrong: some rendering contexts report
       naturalWidth 0 on an image that is complete and perfectly drawable, which
       made the sampler return null for every tile on the page while the canvas
       work underneath it succeeded fine.

       So the test is now the direct one. Draw first, then check whether opaque
       pixels actually arrived, by averaging the alpha channel alongside the
       colour. Nothing drawn leaves the canvas transparent, the alpha average
       falls to 0, and we return null exactly as before. A real photo comes back
       at alpha 255. The threshold sits at 250 rather than 255 so a PNG with a
       faintly soft edge is not thrown away.

       Everything else about the failure path is unchanged: getImageData still
       throws on a tainted canvas, the catch still returns null, and the tile
       keeps the #F5F5F5 floor set in luna-pdp.css. */
    function sampleBg(fig, img){
      try{
        var c = document.createElement('canvas');
        c.width = 10; c.height = 10;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, 40, 40, 0, 0, 10, 10);
        var d = x.getImageData(0, 0, 10, 10).data;
        var rs = 0, gs = 0, bs = 0, as = 0, n = d.length / 4;
        for(var i = 0; i < d.length; i += 4){ rs += d[i]; gs += d[i+1]; bs += d[i+2]; as += d[i+3]; }
        if(as / n < 250) return null;
        var col = 'rgb(' + Math.round(rs/n) + ',' + Math.round(gs/n) + ',' + Math.round(bs/n) + ')';
        fig.style.backgroundColor = col;
        return col;
      }catch(e){ return null; }
    }

    /* D240 (Liv, 09-11) — THE SAMPLER NOW RUNS ON EVERY PDP, NOT JUST CARD MODE.
       Liv: "I have the same background color comment across all product pages
       I've looked at so far."

       This block used to be wrapped in

           if(root.classList.contains('luna-pdp--card')){ ... }

       per the D69 rule at the top of this file, "sampled photo grounds belong
       to card mode ONLY". classList.contains is an exact token match, so
       'luna-pdp--cardw' never satisfied it — and every product template ships
       box_style "cardw". The sampler has therefore never run on a single
       product page since the PDP moved to white-page mode. The static CSS
       colour did all the work, and one static colour cannot be right, because
       the photography is not shot on one ground. Sampled across seven products:

         mono-winged-edition      #F4F4F4 throughout
         oso-flaco-winged-edition #F4F4F4 throughout
         lunacito                 #F1F1F1, #F4F4F4, #FFFFFF, #89AADE
         leadville-trail-1        #F1F1F1, #F4F4F4, #16ADF6, #FFFFFF, #000000
         retro-oso-flaco-1        #F4F4F4, #686B58, #FFFFFF

       D69 WAS NOT WRONG, IT WAS TWO RULES IN ONE. The part worth keeping is
       that a sampled colour must never tint the PAGE outside card mode: card
       mode is a photo-ground page and takes the tint deliberately, white-page
       mode is white and would look dirty. The part that had no business being
       gated is the PER-TILE colour, which is only ever filling the letterbox
       gutters of that tile's own photo. Those two are now separate: the tiles
       always sample, and only card mode tints the root. */
    var tintRoot = root.classList.contains('luna-pdp--card');
    var firstImgTile = null;
    items.forEach(function(it){
      if(it.classList.contains('luna-pdp__gi--video')) return;
      if(!firstImgTile) firstImgTile = it;
      var im = it.querySelector('img');
      if(!im) return;
      var apply = function(){
        var col = sampleBg(it, im);
        if(col && tintRoot && it === firstImgTile){ root.style.backgroundColor = col; }
      };
      if(im.complete){ apply(); }
      im.addEventListener('load', apply);
    });

    function altOwners(alt){
      var an = norm(alt || ''), out = [];
      if(!an) return out;
      colourAxes.forEach(function(ax){
        for(var i = 0; i < ax.norms.length; i++){
          if(an.indexOf(ax.norms[i].n) > -1){ out.push({ axis: ax.name, value: ax.norms[i].v }); break; }
        }
      });
      return out;
    }
    function galleryFor(){
      var mine = [], neutral = [];
      items.forEach(function(it){
        var isVideo = it.classList.contains('luna-pdp__gi--video');
        var owners = isVideo ? [] : altOwners(it.dataset.alt);
        var matches = owners.every(function(o){ return st[o.axis] === o.value; });
        if(owners.length && matches){ it.hidden = false; mine.push(it); }
        else if(!owners.length){ it.hidden = false; neutral.push(it); }
        else {
          it.hidden = true;
          it.classList.remove('is-lead');
          it.classList.remove('is-tail');
          it.classList.remove('is-over');
        }
      });
      var ord = mine.concat(neutral);
      var visN = expanded ? ord.length : Math.min(limit, ord.length);
      ord.forEach(function(it, i){
        it.style.order = i;
        it.classList.toggle('is-lead', i === 0);
        it.classList.toggle('is-tail', i === visN - 1 && i > 0);
        it.classList.toggle('is-over', !expanded && i >= limit);
      });
      if(els.more){
        els.more.hidden = ord.length <= limit;
        els.more.textContent = expanded ? 'Show less' : 'Show all ' + ord.length;
      }
      if(els.count) els.count.textContent = ord.length + ' media';
      return ord;
    }
    if(els.more) els.more.addEventListener('click', function(){
      expanded = !expanded;
      galleryFor();
      if(!expanded) els.gal.scrollIntoView({ behavior:'smooth', block:'start' });
    });

    /* lightbox (D58) */
    var lb = null, lbList = [], lbIdx = 0, lbPrevFocus = null;
    function lbBuild(){
      if(lb) return;
      lb = document.createElement('div');
      lb.className = 'luna-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Product image viewer');
      lb.innerHTML = '<button class="luna-lb__x" type="button" aria-label="Close">&times;</button>' +
        '<button class="luna-lb__nav luna-lb__prev" type="button" aria-label="Previous image">&#8249;</button>' +
        '<img class="luna-lb__img" alt="">' +
        '<button class="luna-lb__nav luna-lb__next" type="button" aria-label="Next image">&#8250;</button>' +
        '<p class="luna-lb__n"></p>';
      root.appendChild(lb);
      lb.addEventListener('click', function(e){
        if(e.target === lb){ lbClose(); return; }
        if(e.target.closest('.luna-lb__x')){ lbClose(); return; }
        if(e.target.closest('.luna-lb__prev')){ lbGo(-1); return; }
        if(e.target.closest('.luna-lb__next')){ lbGo(1); return; }
      });
      document.addEventListener('keydown', function(e){
        if(!lb.classList.contains('is-open')) return;
        if(e.key === 'Escape'){ lbClose(); }
        else if(e.key === 'ArrowLeft'){ lbGo(-1); }
        else if(e.key === 'ArrowRight'){ lbGo(1); }
      });
    }
    function lbShow(){
      var fig = lbList[lbIdx];
      if(!fig) return;
      var img = lb.querySelector('.luna-lb__img');
      var tileImg = fig.querySelector('img');
      img.src = fig.dataset.full || (tileImg ? (tileImg.currentSrc || tileImg.src) : '');
      img.alt = fig.dataset.alt || '';
      img.style.backgroundColor = fig.style.backgroundColor || '';
      lb.querySelector('.luna-lb__n').textContent = (lbIdx + 1) + ' / ' + lbList.length;
    }
    function lbOpen(fig){
      lbBuild();
      lbList = galleryFor().filter(function(it){ return !it.classList.contains('luna-pdp__gi--video'); });
      lbIdx = Math.max(0, lbList.indexOf(fig));
      lbPrevFocus = document.activeElement;
      lb.classList.add('is-open');
      document.documentElement.classList.add('luna-lb-lock');
      lbShow();
      lb.querySelector('.luna-lb__x').focus();
    }
    function lbGo(d){
      if(!lbList.length) return;
      lbIdx = (lbIdx + d + lbList.length) % lbList.length;
      lbShow();
    }
    function lbClose(){
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('luna-lb-lock');
      if(lbPrevFocus && lbPrevFocus.focus) lbPrevFocus.focus();
    }

    if(els.gal) els.gal.addEventListener('click', function(e){
      var p = e.target.closest('[data-pdp-play]');
      if(p){
        var vfig = p.closest('.luna-pdp__gi');
        if(vfig && vfig.dataset.embed){
          vfig.innerHTML = '<iframe src="' + vfig.dataset.embed + '" title="Product video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
        }
        return;
      }
      var fig = e.target.closest('.luna-pdp__gi');
      if(fig && !fig.classList.contains('luna-pdp__gi--video') && !fig.hidden){ lbOpen(fig); }
    });

    function renderPrice(){
      var v = current();
      if(v){ els.price.textContent = money(v.p); }
      else if(data.priceMin === data.priceMax){ els.price.textContent = money(data.priceMin); }
      else { els.price.textContent = 'From ' + money(data.priceMin); }
    }
    function renderShip(){
      if(!els.ship || shipMin <= 0) return;
      var v = current();
      var p = v ? v.p : data.priceMin;
      els.ship.textContent = p >= shipMin ? shipQ : shipFallback;
    }
    function renderTabs(){
      if(!els.tabs) return;
      els.tabs.hidden = !hasDual;
      els.tabs.querySelectorAll('[data-g]').forEach(function(t){
        t.setAttribute('aria-selected', String(t.dataset.g === st.gender));
      });
    }
    function renderSizedir(){
      if(!els.sizedir) return;
      var t = (st.gender === 'w' && hasDual) ? root.dataset.sizedirW : root.dataset.sizedirM;
      if(sizeOpt && t){ els.sizedir.textContent = t; els.sizedir.hidden = false; }
      else { els.sizedir.hidden = true; }
    }
    function renderReadout(){
      if(!els.readout) return;
      if(!st.size){ els.readout.textContent = ''; return; }
      var p = partsOf(st.size);
      els.readout.textContent = p.length > 1
        ? 'Size: ' + p[0] + ' / ' + p[1]
        : 'Size: ' + p[0] + ' · men’s only';
    }
    function renderSizes(){
      if(!sizeOpt || !els.sizes) return;
      els.sizes.innerHTML = sizeOpt.values.map(function(val){
        var parts = partsOf(val);
        if(hasDual && st.gender === 'w' && parts.length === 1) return '';
        if(hasDual && st.gender === 'm' && mensMin > 0){
          var mn = parseFloat(bare(parts[0]));
          if(!isNaN(mn) && mn < mensMin) return '';
        }
        /* D205: only a dual product splits its value into a men's and a women's
           half. Everything else prints the value WHOLE — printing parts[0] threw
           the range away on "Small (M4-6/W6-8)" and printing bare(parts[0]) turned
           "Medium" into "edium". */
        var label;
        if(hasDual){
          label = bare(st.gender === 'm' ? parts[0] : parts[1]);
        } else {
          label = String(val);
        }
        var safe = String(val).replace(/"/g, '&quot;');
        var ok = availableFor(val, originOpt ? st[originOpt.name] : null);
        var res = !ok && originOpt && availableFor(val, otherOrigin());
        return '<button type="button" class="luna-pdp__sz' + (ok ? '' : ' is-oos') + (res ? ' is-rescuable' : '') +
               '" data-s="' + safe + '" aria-label="' + safe + '" aria-pressed="' + (st.size === val) + '"' +
               (ok || res ? '' : ' disabled') + '><b>' + label + '</b></button>';
      }).join('');
      /* D373: measure what was actually RENDERED, not sizeOpt.values. On a dual
         product the printed label is only half the value, so the raw values
         would send every sandal wide. */
      var longest = 0;
      els.sizes.querySelectorAll('.luna-pdp__sz b').forEach(function(b){
        var n = b.textContent.trim().length;
        if(n > longest) longest = n;
      });
      var wide = longest > 5;
      if(wide) szWideCss();
      els.sizes.classList.toggle('luna-pdp__sizes--wide', wide);
    }
    function renderRescue(){
      if(!els.rescue) return;
      els.rescue.innerHTML = '';
      if(!sizeOpt || !st.size || !originOpt) return;
      var okNow = availableFor(st.size, st[originOpt.name]);
      var to = otherOrigin();
      if(!okNow && to && availableFor(st.size, to)){
        if(to === 'USA'){
          els.rescue.innerHTML = '<div class="luna-pdp__rescue"><b>' + st.size + '</b> is sold out. Available as Made in USA.' +
            '<br><button type="button" data-switch="USA">Switch to Made in USA</button></div>';
        } else {
          els.rescue.innerHTML = '<div class="luna-pdp__rescue"><b>' + st.size + '</b> is sold out as Made in USA. Available in the standard version.' +
            '<br><button type="button" data-switch="' + to + '">Switch back</button></div>';
        }
      }
    }
    function renderAtc(){
      var v = current();
      var canBuy = !!(v && v.a) && (!sizeOpt || st.size);
      var noSize = !!sizeOpt && !st.size;
      els.atc.classList.toggle('is-pick', noSize);
      els.atc.disabled = !canBuy && !noSize;
      els.atc.textContent = canBuy ? 'Add to Cart - ' + money(v.p) : (noSize ? 'Select a size' : 'Sold out');
      if(els.stock){
        if(noSize){
          els.stock.textContent = '';
          els.stock.classList.remove('is-out'); els.stock.classList.remove('is-low');
        } else if(canBuy){
          if(v && v.l){
            els.stock.textContent = 'Hurry! Low inventory';
            els.stock.classList.add('is-low'); els.stock.classList.remove('is-out');
          } else {
            els.stock.textContent = 'Item is in stock';
            els.stock.classList.remove('is-low'); els.stock.classList.remove('is-out');
          }
        } else {
          els.stock.textContent = 'Sold out';
          els.stock.classList.add('is-out'); els.stock.classList.remove('is-low');
        }
      }
    }
    function renderUp(){
      if(!els.up || !originOpt) return;
      var on = st[originOpt.name] !== originOpt.values[0];
      els.up.classList.toggle('is-on', on);
      var sw = els.up.querySelector('.luna-sw');
      if(sw) sw.setAttribute('aria-checked', String(on));
    }
    function renderAll(){ renderTabs(); renderSizes(); renderReadout(); renderRescue(); renderPrice(); renderAtc(); renderUp(); renderShip(); renderSizedir(); }

    if(els.tabs) els.tabs.addEventListener('click', function(e){
      var t = e.target.closest('[data-g]'); if(!t) return;
      st.gender = t.dataset.g;
      lsSet(GKEY, st.gender);
      renderTabs(); renderSizes(); renderSizedir();
    });
    if(els.sizes) els.sizes.addEventListener('click', function(e){
      var b = e.target.closest('[data-s]'); if(!b || b.disabled && !b.classList.contains('is-rescuable')) return;
      st.size = b.dataset.s; renderAll();
    });
    if(els.rescue) els.rescue.addEventListener('click', function(e){
      var b = e.target.closest('[data-switch]'); if(!b) return;
      st[originOpt.name] = b.dataset.switch; renderAll();
    });
    if(els.up) els.up.addEventListener('click', function(e){
      if(!e.target.closest('.luna-sw')) return;
      st[originOpt.name] = otherOrigin(); renderAll();
    });
    if(els.axes){
      els.axes.addEventListener('click', function(e){
        var b = e.target.closest('button[data-v]'); if(!b) return;
        var row = b.closest('[data-axis]'); if(!row) return;
        st[row.dataset.axis] = b.dataset.v;
        row.querySelectorAll('button[data-v]').forEach(function(o){ o.setAttribute('aria-current', String(o === b)); });
        var lbl = row.querySelector('[data-axis-label]');
        if(lbl) lbl.textContent = pretty(b.dataset.v);
        expanded = false;
        galleryFor();
        renderAll();
      });
      els.axes.querySelectorAll('[data-axis]').forEach(function(row){
        var lbl = row.querySelector('[data-axis-label]');
        if(lbl && st[row.dataset.axis] != null) lbl.textContent = pretty(st[row.dataset.axis]);
      });
    }

    els.atc.addEventListener('click', function(){
      if(els.atc.classList.contains('is-pick')){
        if(els.sizes){
          els.sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
          els.sizes.classList.remove('is-flash');
          void els.sizes.offsetWidth;
          els.sizes.classList.add('is-flash');
        }
        return;
      }
      var v = current(); if(!v || els.atc.disabled) return;
      els.atc.disabled = true;
      var label = els.atc.textContent;
      var addFn = (window.lunaCart && window.lunaCart.add)
        ? window.lunaCart.add
        : function(items){ return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items:items}) }).then(function(r){ return r.json(); }); };
      addFn([{ id: v.id, quantity: 1 }])
        .then(function(){
          if(st.size) lsSet(KEY, st.size);
          els.atc.classList.add('is-done'); els.atc.textContent = 'Added';
          setTimeout(function(){ els.atc.classList.remove('is-done'); els.atc.textContent = label; els.atc.disabled = false; }, 1200);
        })
        .catch(function(err){
          els.atc.disabled = false;
          els.atc.textContent = (err && err.message) ? err.message : 'Try again';
          setTimeout(function(){ renderAtc(); }, 2400);
        });
    });

    /* D183: one open at a time. D185: and it slides.
       The height has to be driven here because a panel's natural height is auto
       and CSS cannot interpolate to that. Each toggle freezes the current pixel
       height, forces a reflow so the browser has something to animate FROM, then
       sets the target. The open target is measured by flipping to height:auto
       with transitions off and reading the real box - that counts the bottom
       padding the open state turns on, which a plain scrollHeight read would
       miss while that padding is still mid-transition.
       Once open the height goes back to auto, or a later reflow (a webfont
       landing, an image loading) would be clipped by a stale fixed pixel value.
       Scoped to `root`, so a second PDP block keeps its own set. */
    var accs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-acc]'));
    function accBody(t){
      var b = t.nextElementSibling;
      return (b && b.classList.contains('luna-pdp__accB')) ? b : null;
    }
    function naturalHeight(b){
      var hadHeight = b.style.height, hadTrans = b.style.transition;
      b.style.transition = 'none';
      b.style.height = 'auto';
      var h = b.getBoundingClientRect().height;
      b.style.height = hadHeight;
      void b.offsetHeight;
      b.style.transition = hadTrans;
      return h;
    }
    function accSet(t, open){
      var b = accBody(t);
      if(!b){ t.setAttribute('aria-expanded', open ? 'true' : 'false'); return; }
      var from = b.getBoundingClientRect().height;
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      var to = open ? naturalHeight(b) : 0;
      b.style.height = from + 'px';
      void b.offsetHeight;
      b.style.height = to + 'px';
    }
    accs.forEach(function(t){
      var b = accBody(t);
      if(b){
        b.addEventListener('transitionend', function(e){
          if(e.propertyName === 'height' && t.getAttribute('aria-expanded') === 'true'){
            b.style.height = 'auto';
          }
        });
      }
      t.addEventListener('click', function(){
        var opening = t.getAttribute('aria-expanded') !== 'true';
        accs.forEach(function(o){
          if(o !== t && o.getAttribute('aria-expanded') === 'true') accSet(o, false);
        });
        accSet(t, opening);
      });
    });

    var rate = root.querySelector('[data-pdp-rating]');
    if(rate) rate.addEventListener('click', function(){
      var tgt = document.getElementById('luna-reviews');
      if(tgt) tgt.scrollIntoView({ behavior:'smooth', block:'start' });
    });

    if(els.tfc){
      var adopt = function(){
        var w = document.querySelector('.tfc-fitrec-product');
        if(w && !els.tfc.contains(w)) els.tfc.appendChild(w);
      };
      adopt();
      new MutationObserver(adopt).observe(document.body, { childList: true, subtree: true });
    }

    if(els.rebuy){
      var adoptRb = function(){
        document.querySelectorAll('.rebuy-widget.widget-type-product').forEach(function(w){
          if(els.rebuy.contains(w)) return;
          var head = w.querySelector('.primary-title, .rebuy-title, h2, h3');
          var t = head ? head.textContent.toLowerCase() : '';
          if(t.indexOf('complete the look') > -1) els.rebuy.appendChild(w);
        });
      };
      adoptRb();
      new MutationObserver(adoptRb).observe(document.body, { childList: true, subtree: true });
    }

    var also = document.querySelector('[data-pdp-alsolike]');
    if(also){
      var adoptAl = function(){
        document.querySelectorAll('.rebuy-widget.widget-type-product').forEach(function(w){
          if(also.contains(w) || (els.rebuy && els.rebuy.contains(w))) return;
          var head = w.querySelector('.primary-title, .rebuy-title, h2, h3');
          var t = head ? head.textContent.toLowerCase() : '';
          if(t.indexOf('you may also like') > -1) also.appendChild(w);
        });
      };
      adoptAl();
      new MutationObserver(adoptAl).observe(document.body, { childList: true, subtree: true });
    }

    var rec = lsGet(KEY);
    if(sizeOpt && rec && sizeOpt.values.indexOf(rec) > -1 && availableFor(rec, originOpt ? st[originOpt.name] : null)){
      st.size = rec;
    }

    galleryFor();
    renderAll();
  }

  function scan(){ document.querySelectorAll('[data-luna-pdp]').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', scan); }
  else { scan(); }
  document.addEventListener('shopify:section:load', scan);
})();

/* D92: mobile sticky buy bar. Built at runtime so the section markup stays
   untouched; CSS shows it on phones only, after the real ATC scrolls out of
   view. The button proxies the real one, so every rule keeps living in one
   place. */
(function(){
  function boot(){
    var root = document.querySelector('[data-luna-pdp]');
    if(!root || root.__lunaMbar) return; root.__lunaMbar = true;
    var atc = root.querySelector('[data-pdp-atc]');
    var price = root.querySelector('[data-pdp-price]');
    var title = root.querySelector('.luna-pdp__h1');
    if(!atc || !price || !title || !('IntersectionObserver' in window)) return;
    var bar = document.createElement('div');
    bar.className = 'luna-pdp__mbar';
    bar.innerHTML = '<div class="luna-pdp__mbar-t"><b></b><span></span></div><button type="button">Add to Cart</button>';
    bar.querySelector('b').textContent = title.textContent.trim();
    var mprice = bar.querySelector('span'), mbtn = bar.querySelector('button');
    function sync(){
      mprice.textContent = price.textContent.trim().replace(/ +/g, ' ');
      mbtn.disabled = atc.disabled;
      var t = atc.textContent.trim();
      mbtn.textContent = /add to cart/i.test(t) ? 'Add to Cart' : (t || 'Add to Cart');
    }
    sync();
    new MutationObserver(sync).observe(price, { childList: true, characterData: true, subtree: true });
    new MutationObserver(sync).observe(atc, { attributes: true, childList: true, subtree: true });
    mbtn.addEventListener('click', function(){
      if(atc.disabled){ atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      atc.click();
    });
    document.body.appendChild(bar);
    new IntersectionObserver(function(entries){
      var e = entries[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(atc);
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();